
export type CornerSingleSidePOIPoiType = typeof CornerSingleSidePOIPoiType[keyof typeof CornerSingleSidePOIPoiType];


export const CornerSingleSidePOIPoiType = {
  CornerSingleSidePOI: 'CornerSingleSidePOI',
} as const;
